module.exports = __webpack_public_path__ + "img/tab_img_m2.9af6a1f2.jpg";